var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPlayerPlay = function SvgIcPlayerPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_player_play")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_player_play",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0.618033989 C1.1552451,0.618033989 1.30835816,0.654179081 1.4472136,0.723606798 L23.2111456,11.6055728 C23.7051241,11.8525621 23.9053485,12.4532351 23.6583592,12.9472136 C23.5615955,13.140741 23.404673,13.2976635 23.2111456,13.3944272 L1.4472136,24.2763932 C0.953235098,24.5233825 0.352562058,24.3231581 0.105572809,23.8291796 C0.0361450918,23.6903242 0,23.5372111 0,23.381966 L0,1.61803399 C0,1.06574924 0.44771525,0.618033989 1,0.618033989 Z M2.75,4.45 L2.75,20.55 L18.85,12.5 L2.75,4.45 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlayerPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_player_play.ff7ef223.svg";
export { ForwardRef as ReactComponent };